import { Component, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'umkt-oboticario-embed',
  standalone: true,
  templateUrl: './oboticario-embed.component.html',
  styleUrl: './oboticario-embed.component.scss',
})
export class OboticarioEmbedComponent implements OnInit, OnDestroy {
  static readonly BODY_CLASS = 'umkt-oboticario-embed-page';

  private readonly sanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);

  iframeSrc: SafeResourceUrl | null = null;

  ngOnInit(): void {
    this.iframeSrc = this.buildIframeSrc();
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.add(OboticarioEmbedComponent.BODY_CLASS);
      document.documentElement.classList.add(OboticarioEmbedComponent.BODY_CLASS);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.remove(OboticarioEmbedComponent.BODY_CLASS);
      document.documentElement.classList.remove(OboticarioEmbedComponent.BODY_CLASS);
    }
  }

  private buildIframeSrc(): SafeResourceUrl {
    const base = String(
      environment.partnerHubOboticarioUrl || 'https://partner-hub-solucoes.usto.re/oboticario'
    ).replace(/\/$/, '');

    const jwt = this.getJwtFromUrl();
    if (jwt) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `${base}/integrations/access?jwt=${encodeURIComponent(jwt)}`
      );
    }

    const pathWithQuery = this.router.url;
    const [path, query] = pathWithQuery.split('?');
    const suffix = path.replace(/^\/grupoboticario\/?/, '').replace(/\/$/, '');
    const target = suffix ? `${base}/${suffix}/` : `${base}/`;
    const url = query ? `${target}?${query}` : target;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private getJwtFromUrl(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      const jwt = new URLSearchParams(window.location.search).get('jwt');
      if (jwt) {
        return jwt;
      }
    }

    const jwt = this.router.parseUrl(this.router.url).queryParams['jwt'];
    return typeof jwt === 'string' && jwt.length > 0 ? jwt : null;
  }
}
